
































































import { Component, Vue } from "vue-property-decorator";
import FlightProvider from "@/store/entities/flight/flightProvider";

@Component({})
export default class AddProvider extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  flightProvider: FlightProvider = new FlightProvider();
  isEdit: boolean = false;

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    this.flightProvider = this.$store.state.flightProvider.editFlightProvider;
    if (this.flightProvider == null) {
      this.isEdit = false;
      this.flightProvider = new FlightProvider();
      this.flightProvider.companyType = 3;
    } else {
      this.isEdit = true;
    }
  }

  async saveFlightProvider() {
    this.flightProvider.companyType = 3;
    this.flightProvider.type = 3;
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "flightProvider/saveFlightProvider",
        data: this.flightProvider,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "flightProvider/saveFlightProvider",
        data: this.flightProvider,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.airport.editAirport = null;
  }
}
